import React from 'react'
import { render } from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import { browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import Redbox from 'redbox-react'
import webfontloader from 'webfontloader'

import configureStore from './redux/store'
import Root from './pages/Root'
import { restoreSession } from './utils/auth'

webfontloader.load({
  google: {
    families: [ 'Lato:300,400,700', 'BenchNine:400' ]
  },
  classes: false
})

browserHistory.listen(function (location) {
  const path = (/#\/(.*)$/.exec(location.hash) || [])[1]
  if (path) browserHistory.replace(path)
})

const store = configureStore(browserHistory)
const history = syncHistoryWithStore(browserHistory, store)

restoreSession(store)

function renderApp (Component) {
  render(
    <AppContainer errorReporter={Redbox}>
      <Component store={store} history={history} />
    </AppContainer>,
    document.getElementById('app')
  )
}

renderApp(Root)

if (module.hot) {
  module.hot.accept('./pages/Root', () => {
    renderApp(require('./pages/Root').default)
  })
}



// WEBPACK FOOTER //
// ./src/index.js